'use client';

import { PayloadAdminBar, PayloadAdminBarProps } from '@payloadcms/admin-bar';
import { useSelectedLayoutSegments } from 'next/navigation';
import { useRouter } from 'next/navigation';
import React, { useState } from 'react';

import { cn } from '@/utils/cn';

import styles from './AdminBar.module.scss';

const collectionLabels = {
  pages: {
    plural: 'Pages',
    singular: 'Page',
  },
};

const Title: React.FC = () => <span>Dashboard</span>;

export const AdminBar: React.FC<{
  adminBarProps?: PayloadAdminBarProps;
}> = (props) => {
  const { adminBarProps } = props || {};
  const segments = useSelectedLayoutSegments();
  const [show, setShow] = useState(false);
  const collection = (collectionLabels as any)?.[segments?.[1]]
    ? segments?.[1]
    : 'pages';
  const router = useRouter();

  const onAuthChange = React.useCallback((user: any) => {
    setShow(user?.id);
  }, []);

  return (
    <div
      className={cn('adminbar', styles.bar, {
        show: show,
      })}
    >
      <div>
        <PayloadAdminBar
          {...adminBarProps}
          collectionSlug={collection}
          collectionLabels={{
            plural: (collectionLabels as any)[collection]?.plural || 'Pages',
            singular: (collectionLabels as any)[collection]?.singular || 'Page',
          }}
          cmsURL={process.env.NEXT_PUBLIC_SERVER_URL}
          logo={<Title />}
          onAuthChange={onAuthChange}
          onPreviewExit={() => {
            fetch('/next/exit-preview').then(() => {
              router.push('/');
              router.refresh();
            });
          }}
          style={{
            backgroundColor: 'transparent',
            padding: 0,
            position: 'relative',
            zIndex: 'unset',
          }}
        />
      </div>
    </div>
  );
};
